import { useEffect } from 'react';

export const useModalOverlayLock = (open: boolean) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [open]);
};

export default useModalOverlayLock;
